import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PeriodManagementService } from '../../_services/api/period-management.service';
import { ApiResponse } from '../../_models/api-response.model';
import { TopAgent } from '../../_models/agent.model';
import { PeriodClosure, PeriodHistory } from '../../_models/period.model';
import { NotificationService } from '../../_services/app/notification.service';

@Component({
  selector: 'app-admin-period-management',
  imports: [CommonModule, FormsModule],
  templateUrl: './admin-period-management.html',
  styleUrls: ['./admin-period-management.scss']
})
export class AdminPeriodManagement implements OnInit {
  topAgents: TopAgent[] = [];
  periodHistory: PeriodHistory[] = [];
  isLoading = false;
  isClosing = false;
  showConfirmationModal = false;
  

  get currentMonth(): string {
    const now = new Date();
    return now.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
  }

  constructor(private periodService: PeriodManagementService, private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.loadTopAgents();
  }

  loadTopAgents(): void {
    this.isLoading = true;
    this.periodService.getTopAgentsCurrentMonth().subscribe({
      next: (response: ApiResponse<TopAgent[]>) => {
        this.topAgents = response.data || [];
        this.topAgents = this.topAgents.map(agent => ({
          ...agent,
          fullName: `${agent.firstName} ${agent.lastName}`
        }));
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading top agents:', error);
        this.isLoading = false;
      }
    });
  }

  closeCurrentPeriod(): void {
    this.showConfirmationModal = true;
  }

  confirmClosePeriod(): void {
    this.isClosing = true;
    
    this.periodService.closeCurrentPeriod().subscribe({
      next: (response: ApiResponse<PeriodClosure>) => {        
        this.notificationService.showSuccess("Période clôturée avec succès! Meilleur agent: "
            + response.data?.topAgentName 
            +" Points: " + response.data?.topAgentPoints);
        this.loadTopAgents();
        this.closeModal();
        this.isClosing = false;
      },
      error: (error) => {
        console.error('Error closing period:', error);
        this.notificationService.showError('Erreur lors de la clôture de la période');
        this.isClosing = false;
      }
    });
  }

  closeModal(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.showConfirmationModal = false;
  }
}